const html = `<p>Umożliwia&nbsp;prowadzenie analiz dużych ilości danych i&nbsp;efektywne przetwarzanie ogromnych ilości danych przy użyciu najpopularniejszych platform open source, takich jak: Hadoop, Apache Spark, Apache Hive, LLAP, Apache Kafka, Apache Storm i R.&nbsp;</p>
<p><strong>Przykłady:</strong>&nbsp;Databricks, HDInsight</p>
<p><strong>Wiedza i umiejętności wymagane do użycia/zastosowania technologii:</strong> Python, R, Sacla, SQL</p>`;

export default html;
